export default __webpack_public_path__ + "static/media/aryan.b55526d7.jpg";